import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getOpsColor } from "../../../../../utils/helper";
import {
  stepsValues,
  transition,
} from "../../../../PrintMask/SidebarMenu/SidebarMenu";
import {
  ProgressLoader,
  StyledProgressBar,
} from "../../../../Report/new/ProgressBar/ProgressBar-styled";

const PrintMapProgress = ({ config, expanded, t }) => {
  let { step } = useSelector((state) => state.printWidget);
  const activeModule = useSelector((state) => state.activeModule);

  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );

  return (
    <div
      style={{
        padding: "2px",
        maxWidth: !expanded ? 150 : undefined,
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          height: expanded ? 5 : 5,
          minHeight: expanded ? 5 : 5,
          borderRadius: 10,
          overflow: "hidden",
          background: "#a8b1b780",
          position: "relative",
        }}
      >
        <ProgressLoader color={opsColor} />
        <StyledProgressBar
          style={{ transition: `all ${transition[step]}s` }}
          color={opsColor}
          progress={(100 / 4) * (stepsValues[step] ?? 0)}
        />
      </div>
      <span
        style={{
          fontSize: "10px",
          lineHeight: "normal",
        }}
      >
        {t("print.final.loadingSteps." + step)}
      </span>
    </div>
  );
};

export default PrintMapProgress;
